<template>
  <div :class="{ 'sirui-search': false, 'edit-form': true }" ref="sub">
    <el-form
      label-position="right"
      :rules="rules"
      :label-width="labelWidth"
      :model="query"
      ref="queryFrom"
      :validate-on-rule-change="false"
      :disabled="isDisabledForm"
    >
      <el-row :gutter="20">
        <template v-for="(searchColumn, i) in searchColumns">
          <el-row
            :key="i"
            :gutter="10"
            :style="{ display: expand ? 'block' : i == 0 ? 'block' : 'none' }"
          >
            <template v-for="(column, index) in searchColumn">
              <el-col class="search-item" :key="index" :span="column.span || colSpan">
                <el-form-item
                  :label="column.name"
                  :class="{ propClass: column.name.trim().length > propLength }"
                  :prop="column.prop"
                >
                  <el-input
                    :style="searchColumn.length > 3 ? 'width:100%' : 'width:60%'"
                    v-if="column.type == 'input' || column.type == 'inputAmount'"
                    :maxlength="column.maxlength || 32"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder"
                    clearable
                    :disabled="column.disabled || false"
                  >
                    <template slot="append" v-if="column.append">{{ column.append }}</template>
                  </el-input>
                  <el-input
                    :style="'width:100%'"
                    v-if="column.type == 'multipleInput'"
                    :maxlength="column.maxlength || 32"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder"
                    clearable
                    type="textarea"
                    rows="3"
                    :disabled="column.disabled || false"
                  >
                    <template slot="append" v-if="column.append">{{ column.append }}</template>
                  </el-input>
                  <el-select
                    v-if="column.type == 'select'"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder || $t('search.choose')"
                    clearable
                    :disabled="column.disabled || false"
                    @change="change(query[column.prop])"
                  >
                    <el-option
                      v-for="item in column.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="column.type == 'selectMultiple'"
                    multiple
                    clearable
                    :disabled="column.disabled || false"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder || $t('search.choose')"
                  >
                    <el-option
                      v-for="(item, index) in column.options"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <div
                    v-if="
                      column.type == 'attachment' &&
                      query[column.prop] != null &&
                      query[column.prop].length > 0
                    "
                    class="attachment"
                  >
                    <div
                      v-for="(item, index) in query[column.prop]"
                      :key="index"
                      @click="clickAttachment(item)"
                    >
                      {{ item.attachmentName }}
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'TableInfo',
    components: {},
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        },
        pickerStartOptions: {}, // 开始日期配置
        pickerEndOptions: {}, // 结束日期配置
        pickerTimeOptions: {},
        expand: true,
      };
    },
    props: {
      query: {
        type: Object,
        default: () => {},
      },
      labelWidth: {
        type: String,
        default: '120px',
      },
      columns: {
        type: Array,
        default: () => [],
      },
      // 搜索默认分隔的colSpan，默认分成4列
      colSpan: {
        type: Number,
        default: 6,
      },
      // 右边按钮占位，弹窗占位需要宽一点
      buttonSpan: {
        type: Number,
        default: 4,
      },
      rules: {
        type: Object,
        default: () => {},
      },
      // 是否禁用表单
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      // 表单列数
      columnNumber() {
        const colSpan = this.colSpan;
        return Math.floor(24 / colSpan);
      },
      expandText() {
        return !this.expand ? this.$t('search.spread') : this.$t('search.packUp');
      },
      inputTip() {
        return this.$t('search.input');
      },
      selectTip() {
        return this.$t('search.choose');
      },
      searchColumns() {
        let list = [];
        let all = 0;
        // 根据每一列占据的span数组装二维数组
        const colSpan = this.colSpan;
        let children = [];
        this.columns.forEach((item, index) => {
          item.index = index;
          const span = item.span || colSpan;
          if (all + span < 24) {
            all += span;
            children.push(item);
          } else if (all + span === 24) {
            list.push(children.concat(item));
            all = 0;
            children = [];
          } else {
            list.push(children);
            children = [item];
            all = span;
          }
        });
        if (children.length) {
          list.push(children);
        }
        return list;
      },
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 8 : 14;
      },
      buttonCol() {
        return 0;
      },
    },
    methods: {
      clickAttachment(value) {
        window.open(value.attachmentPath, '_blank');
      },
    },
    mounted() {},
  };
</script>
<style lang="scss">
  .popper__arrow::after {
    border-bottom-color: #000000 !important;
  }

  .el-popper-search {
    .popper__arrow::after {
      border-bottom-color: #ffffff !important;
    }
  }
</style>
<style lang="scss" scoped>
  $maintheme: #6299fe;

  .sirui-search {
    box-shadow: 0px 1px 5px #ddd;
  }
  ::v-deep .el-form-item__label {
    font-size: 12px;
  }
  .sirui-search .el-form-item {
    margin-bottom: 12px;
  }

  .search-expand {
    cursor: pointer;
    margin: 0 0 0 1px;
    font-size: 12px;
    color: $maintheme;
  }

  .edit-form {
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .sirui-search {
    background: #fff;
    border-radius: 4px;
    padding: 20px 20px 20px 30px;
    padding-bottom: 3px;
  }

  @media screen and (max-width: 1536px) {
    .text-right {
      .search {
        width: 65px;
      }

      .reset {
        width: 65px;
      }
    }
  }

  .text-right {
    a {
      display: inline-block;
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
      margin-right: 10px;
      text-align: center;
      font-size: 12px;
    }

    img {
      vertical-align: middle;
      padding-right: 6px;
    }

    .search {
      background-color: #409eff;
      color: #ffffff;
    }

    .reset {
      border: 1px solid #e4e6eb;
      color: #409eff;
    }

    .open-btn {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #e4e6eb;
      display: inline-block;
      cursor: pointer;
      color: #00b400;
      text-align: center;
      border-radius: 3px;

      img {
        padding-right: 0;
      }
    }

    .active {
      transform: rotate(180deg);
    }
  }

  .el-button {
    border-radius: 3px;
    border: 1px solid #6299fe;
    color: #6299fe;
    margin-left: 3px;
  }

  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
    color: #fff;
  }

  .line-text {
    font-size: 14px;
    color: #888;
    margin-bottom: 15px;
  }
  .attachment {
    font-size: 12px;
    color: #66b1ff;
    padding: 0 0 0 0;
  }

  ::v-deep .el-select__caret {
    transform: rotateZ(0) !important;
  }

  ::v-deep .el-select__caret.is-reverse {
    transform: rotateZ(180deg) !important;
  }

  ::v-deep .el-icon-arrow-up:before {
    content: '替';
    font-size: 16px;
    visibility: hidden;
  }
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 0px;
  }
</style>
